<template>
  <v-text-field
    autocomplete="off"
    :id="id"
    :ref="id"
    :label="label"
    :placeholder="label"
    v-model="autocompleteText"
    @keydown.tab="tabber($event)"
    @focus="onFocus()"
    @blur="onBlur()"
    @input="input"
    :height="28"
    :append-icon="removeIcon"
    onclick="this.select();"
    @click:append="remove"
    hide-details
    :error-messages="valid() == true ? null : [valid()] "
    :rules="rules"
    dense
    outlined
  ></v-text-field>
</template>

<script>
import axios from "axios";
import { setTimeout } from "timers";

axios.defaults.withCredentials = true;

export default {
  name: "BookingLocationInput",
  components: {},
  model: {
    prop: "location",
    event: "locationChanged",
  },
  computed: {
    removeIcon: function () {
      if (this.removable) {
        return "remove_circle_outline";
      } else {
        return "";
      }
    },
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    enableGeolocation: {
      type: Boolean,
      default: true,
    },
    location: Object,
    removable: {
      type: Boolean,
      default: false,
    },
    error: String,
    soloField: {
      type: Boolean,
      default: true,
    },
    singleLineField: {
      type: Boolean,
      default: true,
    },
    soloInvertedField: {
      type: Boolean,
      default: false,
    },
    flatField: {
      type: Boolean,
      default: false,
    },
    backgroundColour: {
      type: String,
      default: "grey lighten-3",
    },
    rules: Array,
  },
  data: function () {
    return {
      autocompleteText:
        this.location.description != null ? this.location.description : "",
      autocomplete: null,
      timer: null,
      focused: false,
      loading: false,
    };
  },
  watch: {
    location: function (val) {
      this.autocompleteText = val.description;
    },
  },
  mounted: function () {
    var vm = this;

    this.WhenGoogleLoadedDo(function () {
      console.log("Can setup as google loaded");
      vm.setup(vm);
    });

    this.timer = setInterval(function () {
      if (vm.focused == false) {
        vm.autocompleteText = vm.location.description;
      }
    }, 1000);
  },
  beforeDestroy: function () {
    clearTimeout(this.timer);
  },
  methods: {
    WhenGoogleLoadedDo: function (fnt) {
      var vm = this;
      if (typeof google != "undefined") {
        console.log("Google loaded!");
        fnt();
      } else {
        console.log("Google not loaded!");
        setTimeout(function () {
          (function (fnt) {
            vm.WhenGoogleLoadedDo(fnt);
          })(fnt);
        }, 500); // You can set timer as you wish //
      }
    },
    remove: function () {
      this.$emit("removePressed", "");
    },
    valid: function () {
      var valid =
        (this.location.id != null && this.autocompleteText != null) ||
        (this.location.id == null &&
          (this.autocompleteText == null || this.autocompleteText == "") &&
          this.error == null);

      if (this.focused || this.loading) {
        return true;
      }

      if (valid && this.error == null) {
        return true;
      } else {
        if (this.error != null) {
          return this.error;
        }

        return "Please select a location from the dropdown list";
      }
    },
    clear: function (e) {
      this.autocompleteText = "";
    },
    tabber: function (e) {
      this.autocompleteText = document.getElementById(this.id).value;
    },
    completed: function (vm, loc) {
      // console.log(vm);
      // console.log(loc);

      vm.$emit("locationChanged", loc);

      // console.log("location changed");

      vm.$nextTick(function () {
        vm.$refs[vm.id].validate();
      });
    },
    setup: function (vm) {
      const options = {
        // types: [this.types]
      };
      if (this.country) {
        options.componentRestrictions = {
          country: this.country,
        };
      }
      var input = document.getElementById(this.id);
      input.placeholder = "";
      this.autocomplete = new google.maps.places.Autocomplete(input, options);

      let circle = new google.maps.Circle({
        center: this.$store.state.center,
        radius: 10000,
      });

      this.autocomplete.setBounds(circle.getBounds());

      var vm = this;

      this.autocomplete.addListener("place_changed", () => {
        console.log("Place changed");
        vm.loading = true;

        let place = this.autocomplete.getPlace();
        if (!place.geometry) {
          // console.log("no results found");
          this.$emit("no-results-found", place);
          this.loading = false;
          return;
        }

        // console.log(place);
        let addressComponents = {
          street_number: "short_name",
          route: "long_name",
          locality: "long_name",
          administrative_area_level_1: "short_name",
          country: "long_name",
          postal_code: "short_name",
        };
        let returnData = {};
        if (place.address_components !== undefined) {
          // Get each component of the address from the place details
          for (let i = 0; i < place.address_components.length; i++) {
            let addressType = place.address_components[i].types[0];
            if (addressComponents[addressType]) {
              let val =
                place.address_components[i][addressComponents[addressType]];
              returnData[addressType] = val;
            }
          }
          returnData["latitude"] = place.geometry.location.lat();
          returnData["longitude"] = place.geometry.location.lng();
          // return returnData object and PlaceResult object

          var address = place.formatted_address;

          if (place.types.includes("establishment")) {
            address = place.name + ", " + address;
          }

          this.autocompleteText = address;
          this.$emit("placechanged", returnData, place);

          this.sendLocationToServer(
            place.geometry.location.lat(),
            place.geometry.location.lng(),
            this.autocompleteText,
            function (loc) {
              vm.completed(vm, loc);
            }
          );
        }
      });
    },
    sendLocationToServer(latitude, longitude, description, success) {
      axios({
        url: `${this.$store.state.apiUrl}/location/add`,
        method: "POST",
        params: {
          lat: latitude,
          lon: longitude,
          description: description,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(function (res) {
          // console.log(res.data);
          var loc = {
            id: res.data.id,
            description: res.data.description,
            latLng: {
              latitude: res.data.lat,
              longitude: res.data.lon,
            },
          };

          success(loc);
        })
        .catch((err) => console.error(err));
    },
    input() {
      this.location.id = null;
    },
    onFocus() {
      // console.log("Focused");
      this.focused = true;
      this.geolocate();
    },
    onBlur() {
      // console.log("Focused");
      this.focused = false;
      this.$emit("blur");
    },
    // onKeyPress(event) {
    //     console.log(JSON.stringify(this.autocomplete.getFields()));
    //     this.$emit('keypress', event);
    // },
    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    geolocate() {
      try {
        if (this.enableGeolocation) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
              let geolocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              let circle = new google.maps.Circle({
                center: geolocation,
                radius: position.coords.accuracy,
              });
              this.autocomplete.setBounds(circle.getBounds());
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    remove() {
      this.$emit("removePressed");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
